// extracted by mini-css-extract-plugin
export default {"container":"a4Ti5"};